module.exports = __webpack_public_path__ + "img/Profile-5.6fa3c67b.png";